<div class="card settings-page">
  <div class="action-panel">
    <app-search-input
      placeholder="Search"
      [searchDelayTime]="0"
      [formControl]="searchControl"
    />

    <app-button
      *appHasRole="['Admin', 'Manager', 'Preparer']"
      id="add-tag-dd"
      text="Add Tags"
      iconClass="icon ic-add-20"
      (clickBtn)="addTag()"
    />
  </div>

  <div class="card-body">
    @if (!isLoading()) {
      <app-list-grid-client-side
        [rowData]="filteredTagList()"
        [colDefs]="colDefs()"
        [rowSelection]="manageTagsRowSelection"
        [suppressRowClickSelection]="true"
        [paginationPageSize]="pageSizeService.getPageSize"
        [paginationPageSizeSelector]="true"
        [suppressCellFocus]="true"
      />
    }

    <app-loader [loading]="isLoading()"/>
  </div>
</div>
